module.exports = __webpack_public_path__ + "img/circle.5a945e27.svg";